export const cashierState = {
    basket: null
};
export const cashierGetters = {};
export const cashierMutations = {
    setCashierBasket(state, data){
        state.cashier.basket = data;
    }
};
